module.exports = __webpack_public_path__ + "img/34.dc931a3e.jpg";